import Vue from 'vue';
import IframeEventService from '@/services/IframeEventService';

/**
 * Vue Plugin for iframe events
 *
 * Usage in components:
 *   this.$iframeEvents.emitStatusPage({ status, resolution, id });
 *   this.$iframeEvents.isInsideIframe();
 */
const IframeEventsPlugin = {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$iframeEvents', {
      get() {
        return IframeEventService;
      },
    });
  },
};

export default function () {
  Vue.use(IframeEventsPlugin);
}
